import useAlternateContactFormStyles from './AlternateContactForm.styles';
import StateDropdown from '../inputs/StateDropdown';
import { useCart } from '../../../contexts/CartContext/CartContext.hooks';
import BaseInputField from '../inputs/BaseInputField/BaseInputField';
import { useEffect, useState } from 'react';

const AlternateContactForm = () => {
    const styles = useAlternateContactFormStyles();
    const { cart, updateAlternateContact } = useCart();

    const [firstName, setFirstName] = useState(cart.alternateContact.firstName);
    const [lastName, setLastName] = useState(cart.alternateContact.lastName);
    const [addressLine1, setAddressLine1] = useState(cart.alternateContact.address.addressLine1);
    const [addressLine2, setAddressLine2] = useState(cart.alternateContact.address.addressLine2);
    const [city, setCity] = useState(cart.alternateContact.address.city);
    const [state, setState] = useState(cart.alternateContact.address.state);
    const [zipcode, setZipcode] = useState(cart.alternateContact.address.zipcode);
    const [phoneNumber, setPhoneNumber] = useState(cart.alternateContact.phoneNumber);

    useEffect(() => {
        updateAlternateContact({
            firstName,
            lastName,
            address: {
                addressLine1,
                addressLine2,
                city,
                state,
                zipcode
            },
            phoneNumber
        });
    }, [name, addressLine1, addressLine2, city, state, zipcode, phoneNumber]);

    return (
        <form name={'AlternateContactForm'} className={styles.root}>
            <div className={styles.inquiryContactInfo}>
                <BaseInputField
                    name='alternatefirstName'
                    label='First Name'
                    className={styles.firstNameContainer}
                    required
                    defaultValue={firstName}
                    onChange={setFirstName}
                />

                <BaseInputField
                    name='alternateLastName'
                    label='Last Name'
                    className={styles.lastNameContainer}
                    required
                    defaultValue={lastName}
                    onChange={setLastName}
                />

                <BaseInputField
                    name='addressLine1'
                    label='Address Line 1'
                    className={styles.address1Container}
                    required
                    defaultValue={addressLine1}
                    onChange={setAddressLine1}
                />

                <BaseInputField
                    name='addressLine2'
                    label='Address Line 2'
                    className={styles.address2Container}
                    defaultValue={addressLine2}
                    onChange={setAddressLine2}
                />

                <BaseInputField
                    name='city'
                    label='City'
                    className={styles.cityContainer}
                    required
                    defaultValue={city}
                    onChange={setCity}
                />

                <StateDropdown
                    className={styles.stateContainer}
                    required
                    showOnlyValidMarkets={true}
                    value={state}
                    onChange={setState}
                />

                <BaseInputField
                    name='zipcode'
                    label='Zipcode'
                    className={styles.zipcodeContainer}
                    required
                    defaultValue={zipcode}
                    onChange={setZipcode}
                />

                <BaseInputField
                    name='phoneNumber'
                    label='Phone Number'
                    className={styles.phoneNumberContainer}
                    required
                    defaultValue={phoneNumber}
                    onChange={setPhoneNumber}
                />
            </div>
        </form>
    );
};

export default AlternateContactForm;
